import cloneDeep from 'lodash/cloneDeep';
//import {APP_CONFIGS} from "../../config/configs";

const DEFAULT_ORIGIN = null;//APP_CONFIGS.CITY_PAIRS.en.find(cp => cp.code === 'PDL');
const DEFAULT_DESTINATION = null;//APP_CONFIGS.CITY_PAIRS.en.find(cp => cp.code === 'LIS');

export const COURSE = cloneDeep({
    refreshing: false,
    origin: DEFAULT_ORIGIN,
    destination: DEFAULT_DESTINATION,
    dateStart: null,
    dateEnd: null,
    errors: []
});

const DEFAULT_STATE = {
    roundTrip: 'RETURN',
    imagineMode: false,
    adultsAmount: 1,
    childrenAmount: 0,
    infantsAmount: 0,
    passengerType: 'ADULT',
    promoCode: typeof window.CODE === 'string' ? window.CODE.substring(0,6) : '',
    passengerTypeWasChanged: false,
    legs: [{...COURSE}, {...COURSE}]
};

export default cloneDeep(DEFAULT_STATE);